export const useProgressbarStore = defineStore('progressbar', () => {
  const isLoading = ref(false)
  const teleportTo = ref('body')

  function showLoading() {
    isLoading.value = true
  }

  function hideLoading() {
    isLoading.value = false
  }

  const setTeleportTo = (to = 'body') => {
    teleportTo.value = to
  }

  return {
    isLoading,
    teleportTo,
    setTeleportTo,
    showLoading,
    hideLoading
  }
})
